import axios from "axios";
import Vue from "vue";
import siteConfig from "../config.js";
import events from "../utils/event.js";

if (!siteConfig[process.env.NODE_ENV]) {
  alert("请先完成配置文件和指定node环境");
}
const baseURL = siteConfig[process.env.NODE_ENV].apiPort;
let errorToasted = false;

let instance = axios.create({
  timeout: 100000,
  validateStatus: function(status) {
    if (status == 502) {
      if (!errorToasted) {
        events.$emit("network-error", status);
        errorToasted = true;
      }
    }
    return status >= 200 && status < 300; // default
  }
});

function config(prefix) {
  const base = {
    baseURL: baseURL + prefix,
    "Content-Type": "application/json;charset=UTF-8"
  };
  if (localStorage.getItem("user")) {
    base.headers = {
      Authorization: "Bearer " + localStorage.getItem("user").replace(/(^\")|(\"$)/g, "")
    };
  }
  if (base.headers) {
    base.headers.nanoId = localStorage.getItem("nanoId");
  } else {
    base.headers = {
      nanoId: localStorage.getItem("nanoId")
    };
  }
  return base;
}

export { instance, config }
